import * as AspectRatioPrimitive from "@radix-ui/react-aspect-ratio";
import { cn } from "@/lib/utils";

function AspectRatio({
  className,
  ...props
}: React.ComponentProps<typeof AspectRatioPrimitive.Root>) {
  return (
    <AspectRatioPrimitive.Root
      className={cn("wl-aspect-ratio", className)}
      data-slot="aspect-ratio"
      {...props}
    />
  );
}

export { AspectRatio };
